import { nothing } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import { LibElement } from '../lib-element';

@customElement('lib-tagbox-option')
export class LibTagBoxOption extends LibElement {
  static override readonly styles = [LibElement.hostStyles];
  @property({ reflect: true }) value = '';
  override render() { return nothing; }
}

declare global {
  interface HTMLElementTagNameMap { 'lib-tagbox-option': LibTagBoxOption; }
}
